import { render } from "./impupload.vue?vue&type=template&id=65b3baf4"
import script from "./impupload.vue?vue&type=script&lang=js"
export * from "./impupload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__